import {
  Heading,
  HStack,
  Stack,
  Text,
  VStack,
  Spinner,
  Button,
} from "@chakra-ui/react";
import { useLoading } from "../hooks/form";
import { useCallback, useEffect, useState } from "react";
import actions from "../../actions";
import { KYDBatchPayout } from "@common/interfaces/KYDOrganization";
import { useDialog } from "../../Common/Dialog";
import { Link, useParams } from "react-router-dom";
import PayoutDetailsTable from "./PayoutDetailsTable";
import dayjs from "dayjs";
import { ChevronLeftIcon } from "@chakra-ui/icons";

const PayoutDetails = () => {
  const { payout_id } = useParams();
  const [loading, updateLoading] = useLoading({
    init: true,
  });
  const [payout, setPayout] = useState<KYDBatchPayout>();
  const dialog = useDialog();

  const fetchPayout = useCallback(async () => {
    updateLoading("init", true);
    try {
      const _ = await actions.ADMIN.fetchSingleOrganizationPayout({
        id: payout_id as string,
      });
      setPayout(_);
    } catch (err) {
      dialog({ text: err.message });
    }
    updateLoading("init", false);
  }, [updateLoading, dialog]);

  const handleDownloadPayoutCSV = useCallback(async () => {
    const { url } = await actions.ADMIN.fetchPayoutDetailsReport({
      payout_id,
    });
    // The response from fetchPayoutDetailsReport is an S3 URL
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.download = `payout-${payout_id}.csv`;
    a.click();
  }, []);

  useEffect(() => {
    fetchPayout();
  }, [fetchPayout]);

  return (
    <Stack spacing={{ base: "4", lg: "6" }}>
      {loading["init"] ? (
        <VStack>
          <Spinner />
          <Text>Loading payouts...</Text>
        </VStack>
      ) : (
        <VStack
          h="full"
          w="full"
          spacing="4"
          alignItems={"flex-start"}
          gap={"32px"}
        >
          <HStack spacing="1" width={"full"} justifyContent={"space-between"}>
            <VStack alignItems={"flex-start"} gap={"40px"}>
              <Button
                as={Link}
                padding={0}
                to={`/payouts`}
                variant="link"
                fontSize={"20px"}
                fontWeight={"400"}
                color="black"
              >
                <ChevronLeftIcon ml={"-6px"} />
                Back to Payouts
              </Button>
              <Heading fontSize={"20px"} fontWeight="600">
                Payout Period {dayjs(payout?.start_at).format("MMMM D, YYYY")} -{" "}
                {dayjs(payout?.end_at).format("MMMM D, YYYY")}
              </Heading>
            </VStack>
            <Button
              onClick={handleDownloadPayoutCSV}
              variant="outline"
              size="sm"
              py={4}
              px={4}
              borderRadius={"10px"}
              backgroundColor="black"
              color="white"
              ml={2}
            >
              Download
            </Button>
          </HStack>
          <Stack
            h="full"
            w="full"
            flexGrow={1}
            spacing={{ base: "5", lg: "6" }}
          >
            <PayoutDetailsTable payout={payout} />
          </Stack>
        </VStack>
      )}
    </Stack>
  );
};

export default PayoutDetails;
